export default __webpack_public_path__ + "assets/webgl/scene-7.c5e6a96c.glb";